import {
    DEALERADDUPDATEDSRLIMITS_FAILED,
    DEALERADDUPDATEDSRLIMITS_SUCCESS,
    RESET_DEALERADDUPDATEDSRLIMITS,
    LOADING_DEALERADDUPDATEDSRLIMITS,
    NETWORK_ERROR_DEALERADDUPDATEDSRLIMITS
} from '../types/index'

import { dealerServices } from "../../config/axios";

const resetDealerAddUpdateDsrLimits = () => {
    return { type: RESET_DEALERADDUPDATEDSRLIMITS };
};


const dealerAddUpdateDsrLimits = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERADDUPDATEDSRLIMITS });
    await dealerServices
        .post("addUpdateDsrLimits", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerAddUpdateDsrLimitssuccess(res.data));
                    break;
                default:
                    dispatch(dealerAddUpdateDsrLimitsFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERADDUPDATEDSRLIMITS,
                payload: err
            });
        });
}

function dealerAddUpdateDsrLimitssuccess(data) {
    return {
        type: DEALERADDUPDATEDSRLIMITS_SUCCESS,
        payload: data
    };
}
function dealerAddUpdateDsrLimitsFailed(data) {
    return {
        type: DEALERADDUPDATEDSRLIMITS_FAILED,
        payload: data
    };
}


export { resetDealerAddUpdateDsrLimits, dealerAddUpdateDsrLimits }